import React, { useState } from 'react';
import Head from 'next/head';

import useMount from 'src/common/hooks/useMount';
import { isAppleIOS } from 'src/common/platformUtils/isAppleIOS';

const DisableIOSZoomingMeta = () => {
  const [isiOSDevice, setIsiOSDevice] = useState(false);
  useMount(() => {
    const isIOS = isAppleIOS();
    setIsiOSDevice(isIOS);
  });

  return isiOSDevice ? (
    <Head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
        key="viewport"
      />
    </Head>
  ) : null;
};

export default DisableIOSZoomingMeta;
